import { render, staticRenderFns } from "./ProductAdder.vue?vue&type=template&id=43c50fad&scoped=true&"
import script from "./ProductAdder.vue?vue&type=script&lang=js&"
export * from "./ProductAdder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43c50fad",
  null
  
)

export default component.exports